import {Component, OnDestroy, OnInit} from '@angular/core';
import {IonicPage, Modal, ModalController, NavController, PopoverController} from 'ionic-angular';
import {KontaktePage} from "../kontakte/kontakte";
import {PruefungPage} from "../pruefung/pruefung";
import {SelectKundeComponent} from "../../components/select-kunde/select-kunde";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {VorlageneditorPage} from "../vorlageneditor/vorlageneditor";
import {ModalNavPage} from "../modal-nav/modal-nav";
import {ExistsAuditCustomerPage} from "../exists-audit-customer/exists-audit-customer";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/toArray";
import "rxjs/add/operator/concatAll";
import "rxjs/add/operator/mergeAll";
import "rxjs/add/operator/concatMap";
import "rxjs/add/operator/combineAll";
import {SettingPage} from "../setting/setting";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {LoginPage} from "../login/login";
import {CookieService} from "ngx-cookie-service";
import {GlobalProvider} from "../../providers/global/global";
import {HttpClient} from "@angular/common/http";
import {LoginProvider} from "../../providers/login/login.provider";
import {AuditEntity} from "../../store/audit/audit.entity";
import {AuditService} from "../../store/audit/audit.service";

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit, OnDestroy {

  // public documents: Array<any> = [];
  // public userId: string = null;

  private _loginModal: Modal = this.modalCtrl.create(ModalNavPage, {page: LoginPage}, {enableBackdropDismiss: false});

  constructor(public navCtrl: NavController,
              private popoverCtrl: PopoverController,
              private dataProvider: DataProvider,
              // private pruefungProvider: PruefungProvider,
              private modalCtrl: ModalController,
              private loadingProvider: LoadingServiceProvider,
              public globalProvider: GlobalProvider,
              private cookieService: CookieService,
              private http: HttpClient,
              private loginProvider: LoginProvider,
              private auditService: AuditService) {

    let isBrowser = this.globalProvider.isBrowser();

    console.dir('isBrowser: ' + isBrowser);

  }

  ngOnInit() {
    return this._checkIfLoginIsNeeded();
  }

  private _checkIfLoginIsNeeded(): Promise<any> {

    return this.loginProvider.isLoggedIn()
      .then(() => {
        this.dataProvider.stopAllSync();
        this.dataProvider.initLocalDB();
        this.dataProvider.init();
        return true;
      }, () => {
        this._loginModal = this.modalCtrl.create(ModalNavPage, {page: LoginPage}, {enableBackdropDismiss: false});
        return this._loginModal.present()
      })
  }

  public openPageKontakte(): void {
    this.navCtrl.push(KontaktePage);
  }

  public newPruefung(ev: UIEvent): void {

    let _selectKundePopover = this.modalCtrl.create(SelectKundeComponent);
    _selectKundePopover.onDidDismiss((customerId) => {
      if (customerId) {

        const newAudit: AuditEntity = {
          system: false,
          userId: this.globalProvider.user.uuid,
          docType: 'audit',
          docName: 'Prüfung',
          customerId: customerId,
          erstellungsDatum: new Date(),
          protokolle: []
        };

        this.auditService.add(newAudit, false)
          .then((audit: AuditEntity) => {
            this.navCtrl.push(PruefungPage, {pruefungId: audit._id});
          });
      }
    });
    _selectKundePopover.present({
      ev: ev
    });
  }

  public openExistPruefung(): void {

    //open modal with customer who has a pruefung, after select a customer we have to show the created protocols
    let selectExistPruefungModal = this.modalCtrl.create(ModalNavPage, {page: ExistsAuditCustomerPage});
    selectExistPruefungModal.onDidDismiss((data) => {
      if (data) {
        this.navCtrl.push(PruefungPage, {pruefungId: data.pruefungId, protokollId: data.protokollId});
      }
    });

    selectExistPruefungModal.present();

  }

  public openPageTemplateeditor(): void {
    this.navCtrl.push(VorlageneditorPage);
  }


  public openSettingPage(): void {
    this.navCtrl.push(SettingPage);
  }

  public save(row: any) {
    row.save();
  }

  public logout() {
    this.loginProvider.setLoggedOut();
    this.dataProvider.stopAllSync();
  }

  /**
   * @Description: lässt eine einmalige replizierung der jetzigen Datenbank zur ausgewählten Datenbank erstellen.
   */
  public takeOverData() {

    let postParams = {
      userUUID: this.cookieService.get('userUUID')
    }

    this.http.post(this.globalProvider.apiURL + '/v1/getUserWritableDatabases', postParams)
      .subscribe((response) => {

        console.dir(response);

      })
  }

  ngOnDestroy() {
    this._loginModal.getImplementation().dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts